import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { fetchRequest } from '../../../libs/fetchRequest';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import Inputmask from 'inputmask';
import { Table } from 'react-bootstrap';
import moment from 'moment';
import swal from 'sweetalert';
import { getDateHour } from '../../../libs/services';
import { getFormatHour } from '../../../libs/functions';

class SampleReceptionForm extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.changeCombo = this.changeCombo.bind(this);
        this.addSample = this.addSample.bind(this);
        this.calculateValuesBIO = this.calculateValuesBIO.bind(this);
        this.handleTypeAheadChange = this.handleTypeAheadChange.bind(this);

        this.state = {
            sample_number:"",
            date:"",
            hour:"",
            sample_type:"",
            sample_type_name:"",
            sample_types:[],
            tube_type:"",
            tube_type_name:"",
            tube_types:[],
            origin:"",
            origins:[],
            delivered_by:"",
            expiration_date:"",
            temperature:"",
            biometrics:[],
            indice:-1,
            isLoading:false,
            list:[],
            observations:"",
            edit:false,
            id:"",
            selected_origin:[],
            index:-1,
            medicals:[]
        }
    }

    async componentDidMount(){
        var selector = document.getElementById("hour");
		var im = new Inputmask("--:--");
        im.mask(selector);
        
        var response = await fetchRequest({
            url:'lookups/order_by?type=SAMPLE_TYPE&option=name'
        });

        if(response !== undefined){
            this.setState({sample_types: response});
        }

        response = await getDateHour();
        if(response !== undefined){
            var aux = response.split('|');
			var date = aux[0].split("/");
            var hours = getFormatHour(aux[1]); 

			this.setState({
                date:date[2]+'-'+date[1]+'-'+date[0],
                hour: hours
			});
        }

        response = await fetchRequest({
            url:'lookups/order_by?type=TUBE_TYPE&option=name'
        });

        if(response !== undefined){
            this.setState({tube_types: response});
        }

        response = await fetchRequest({
            url:'national_centers?option&health_facility='+sessionStorage.getItem('health_facilities_id')
        });

        if(response !== undefined){
            this.setState({origins: response});
        }

        response = await fetchRequest({
            url:'medical_staff?option=mainInfo&type=NURSE'
        });
        if(response !== undefined){
            this.setState({medicals: response});
        }

        response = await fetchRequest({
            url:'biometrics?option=BIO_F_PHYSICAL&sex='
        });

        if(response !== undefined){
            this.setState({biometrics: response});
        }

        if(this.props.match.params.id !== undefined){
            response = await fetchRequest({
                url:'samples_reception/'+this.props.match.params.id,
                modal: this.props.waiting,
                message_modal: 'Cargando...'
            });

            if(response !== undefined){
                this.setState({
                    sample_number: response.sample_number,
                    date: moment(response.date).format('YYYY-MM-DD'),
                    hour:moment(response.hour, 'HH:mm:ss').format('HH:mm'),
                    sample_type: response.sample_type,
                    tube_type: response.tube_type,                    
                    expiration_date: moment(response.expiration_date).format('YYYY-MM-DD'),
                    temperature: response.storage_temperature,
                    observations: response.observations,
                    edit:true,
                    id:response.id
                });

                var index = this.state.origins.findIndex(obj => obj.id === response.national_center_id);
                
                if(index !== -1){
                    this.setState({indice: index});
                    this.handleTypeAheadChange([this.state.origins[index]], 'origin');
                    this._typeahead.getInstance().setState({text:this.state.origins[index].name})
                }

                index = this.state.medicals.findIndex(obj => obj.medical_staff.id === response.delivered_by);

                if(index !== -1){
                    this.setState({indice: index});
                    this.handleTypeAheadChange([this.state.medicals[index]], 'delivered_by');
                    this._typeahead_delivered.getInstance().setState({
                        text:this.state.medicals[index].medical_staff.lastname1+' '+
                            (this.state.medicals[index].medical_staff.lastname2 !== null ? this.state.medicals[index].medical_staff.lastname2 : "")+' '+
                            this.state.medicals[index].medical_staff.names
                    })
                }

                var biometrics = this.state.biometrics;

                biometrics.forEach(bio => {
                    index = response.physical_verification.findIndex(item => item.biometric_id === bio.id);

                    if(index !== -1){
                        bio.physical_verification_id = response.physical_verification[index].id
                        bio.value = response.physical_verification[index].value;
                        document.getElementById('biometric_'+bio.id).value = bio.value;
                    }else{
                        bio.physical_verification_id = 0;
                        bio.value = "";
                    }
                })
            }
        }
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});

        if(e.target.name === 'hour'){
            var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
        }else if(e.target.name === 'sample_type'){
            this.setState({sample_type_name: e.target.options[e.target.selectedIndex].text});
        }else if(e.target.name === 'tube_type'){
            this.setState({tube_type_name: e.target.options[e.target.selectedIndex].text});
        }
    }

    _handleSearch = (query) => {
	    this.setState({
	    	isLoading:true,
			indice:-1,
	    });
    }
    
    handleTypeAheadChange(values, name){        
        if(values.length > 0){
    		this.setState({
    			isLoading:false,
                [name]: name === 'origin' ? values[0].id : values[0].medical_staff.id,
                index:0,                
	        });     	
        }
    }

    changeCombo(e, i){
		var biometrics = this.state.biometrics;

		biometrics[i].value = e.target.value;

		this.setState({biometrics: biometrics});
    }

    async addSample(){
        var error  = '';
        if(this.isValidForm()){
            var obj = {
                sample_number: this.state.sample_number,
                date: moment(this.state.date).format('YYYY-MM-DD'),
                hour: moment(this.state.hour, 'HH:mm').format('HH:mm:ss.sss'),
                sample_type: this.state.sample_type,
                tube_type: this.state.tube_type,
                national_center_id: this.state.origin,
                delivered_by: this.state.delivered_by,
                expiration_date: moment(this.state.expiration_date).format('YYYY-MM-DD'),
                storage_temperature: this.state.temperature,
                observations: this.state.observations,
                physical_verification:[]
            };
            this.state.biometrics.forEach(bio=>{
                var value = document.getElementById('biometric_'+bio.id).value
                if(value !== ""){
                    var item = {
                        biometric_id: bio.id,
                        value: value
                    };

                    if(this.state.edit){
                        item.id = bio.physical_verification_id
                    }
                    obj.physical_verification.push(item);
                }
            });

            if(this.state.hour.indexOf('--') !== -1){
                error = 'Hora no valida';
            }

            if(this.state.edit){
                obj.id = this.state.id;
            }

           
            if(error === ''){
                var response = await fetchRequest({
                    url:'samples_reception'+(this.state.edit ? '/'+this.state.id : ""),
                    method: this.state.edit ? 'PUT' : 'POST',
                    obj: obj,
                    modal: this.props.waiting,
                    message_modal:'Guardando...'
                });

                if(response !== undefined){
                    var list = this.state.list;


                    list.push({
                        sample_number: obj.sample_number,
                        date_hour: moment(this.state.date).format('DD/MM/YYYY')+' '+this.state.hour,
                        sample_type: this.state.sample_type_name,
                        tube_type: this.state.tube_type_name,
                        delivered_by: this.state.delivered_by
                    });

                    this.setState({
                        list:list,
                        sample_number:"",
                        date:"",
                        hour:"",
                        sample_type:"",
                        sample_type_name:"",
                        tube_type:"",
                        tube_type_name:"",
                        origin:"",
                        delivered_by:"",
                        expiration_date:"",
                        temperature:"",
                        indice:-1,
                        isLoading:false,
                        observations:""
                    });

                    this._typeahead.getInstance().clear();
                }
            }else{
                swal('Error', error, 'error');
            }
            
        }else{
            swal('Error', 'Campos incompletos', 'error');
        }
    }

    isValidForm() {
	    const inputs = document.querySelectorAll('input, select');
	    let isFormValid = true;
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showInputError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	  
	    
	    return isFormValid;
    }
    
    showInputError(refName) {
		const control = document.getElementById(refName);
        
        if(control !== null){
            if(control.value === ""){
                if(control !== null){
                    control.classList.add('error');
                }
                return false;
            }else{
                if(control.className.includes('error')){
                    control.classList.remove('error');
                }
                return true;
            }
        }
    }
    
    calculateValuesBIO(e){
		var control = "";

		this.validateRangeBiometric(e.target.id, e.target.value);
		for (var i = 0; i < this.state.biometrics.length; i++) {
			if (this.state.biometrics[i].data_type === "BIO_D_CALCULATED") {
				var str = (this.state.biometrics[i].formula).split('&');
				var value = this.getTerms(str,'biometric_');
				control = document.getElementById('biometric_'+this.state.biometrics[i].id)
				
				if(value !== ""){
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}
                    control.value = value;
                    this.state.biometrics[i].value = value;
                    this.forceUpdate();
					control.classList.remove('error');
				}else{
					control.classList.add('error');
					control.value = "";
				}
			};
		};
		if(e.target.value.indexOf('.') !== -1){
			this.setState({max_length_bio: "5"});
		}else{
			this.setState({max_length_bio: "4"});
		}
		if(e.target.id !== null){
			control = document.getElementById(e.target.id);
			if(e.target.value !== ""){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}else if(control.className.includes('error')){
					control.classList.remove('error');
				}
			}else{
				control.classList.add('error');
			}
		}
    }

    getTerms(term,type){
		var result = "";
		var formula = "";
		for (var i = 0; i < term.length; i++) {
			var id = parseFloat( term[i] );
			if (!isNaN(id)) {
				formula = formula + this.getItemValue(type+id.toString());
			}else {
				formula = formula + term[i];
			};
		};

		try{
			result =  eval(formula);
		}catch(e){
			//swal('Error', 'Verifique todos sus valores antes de calcular','error');
			return "";
		}

		if (!isNaN(result)) {
			return (result).toFixed(2);
		} else{
			return "";
		};
	}
    
    getItemValue(id){
		return document.getElementById(id).value;
    }
    
    validateRangeBiometric(id, value){
		for(var i =0; i < this.state.biometrics.length;i++){
			if(id.toString() === 'biometric_'+this.state.biometrics[i].id.toString()){
				if(this.state.biometrics[i].ranges_validation){//Si el biometrico tiene rango de valores
					var aux = parseFloat(value);
					if(this.state.donor.person.sex === "HOMBRE"){//Valores para hombre
						//Desmarcar el color rojo del control
						if(aux >= this.state.biometrics[i].low_rank_male && aux <= this.state.biometrics[i].high_rank_male){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}else{//Valores para mujer
						//Desmarcar el color rojo del control
						if(aux >= this.state.biometrics[i].low_rank_female && aux <= this.state.biometrics[i].high_rank_female){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}
				}	
			}
		}
	}
    
    render(){
        const {t} = this.props;

        return(
            <div className="col-xs-12">
                <div className="route">
                    <h5 className="title_page" >
                        {sessionStorage.getItem('health_facilities_name') + ' -> '}
                        {t('sidebar.nav.laboratory.MAIN') + ' -> '}
                        Recepción de Muestras {' -> '} Registro
                    </h5>
                </div>
                <div className="col-xs-12">
                    <div className="col-xs-12 form-group">                        
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">No. de Muestra</span>
                            <input name="sample_number" id="sample_number" value={this.state.sample_number} onChange={(e)=>this.handleChange(e)} className="form-control" required 
                                disabled={this.state.edit}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-1">
                            <span className="span-min">Fecha</span>
                            <input type="date" name="date" id="date" disabled value={this.state.date} onChange={(e)=>this.handleChange(e)} className="form-control hour-input" required />
                        </div>
                        <div className="col-xs-12 col-sm-1">
                            <span className="span-min">Hora</span>
                            <input id="hour" name="hour" id="hour" disabled type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
                                data-inputmask-placeholder="-" value={this.state.hour || ""} onChange={this.handleChange}
                                required className="form-control"/>
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">Tipo de Muestra</span>
                            <select name="sample_type" id="sample_type" value={this.state.sample_type} onChange={(e)=>this.handleChange(e)} className="form-control" required
                                disabled={this.state.edit}
                            >
                                <option value="">Seleccione...</option>                                
                                {this.state.sample_types.map((sample, i)=>
                                    <option key={i} value={sample.key}>{sample.name}</option>
                                )}
                            </select>
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">Tipo de Tubo</span>
                            <select name="tube_type" id="tube_type" value={this.state.tube_type} onChange={(e)=>this.handleChange(e)} className="form-control" required>
                                <option value="">Seleccione...</option>
                                {this.state.tube_types.map((tube, i)=>
                                    <option key={i} value={tube.key}>{tube.name}</option>
                                )}
                            </select>
                        </div>
                        <div className="col-xs-12 col-sm-4">
                            <span className="span-min">Procedencia</span>                            
                            <AsyncTypeahead
                                labelKey={(option) => `${option.name}`}
                                minLength={0}
                                name="national_center"
                                id="national_center" 
                                inputProps={{
                                    autoComplete:"off",
                                    name:'national_center_id',
                                    id:'national_center_id',
                                    required:this.state.sample_type === 'PATIENTS'
                                }}
                                options={this.state.origins}
                                onSearch={this._handleSearch}
                                onChange={(e)=>this.handleTypeAheadChange(e, 'origin')}
                                ref={ref => this._typeahead = ref}
                                delay={600}
                                isLoading={this.state.isLoading}
                                paginationText="Mostrar mas resultados..."
                            />
                        </div>
                    </div>
                    <div className="col-xs-12 form-group">                        
                        <div className="col-xs-12 col-sm-3">
                            <span className="span-min">Entregada por</span>
                            <AsyncTypeahead
                                labelKey={(option) => `${
                                    option.medical_staff.lastname1+' '+(option.medical_staff.lastname2 !== null ? option.medical_staff.lastname2 : "")+' '+option.medical_staff.names
                                }`}
                                minLength={0}
                                name="delivered"
                                id="delivered" 
                                inputProps={{
                                    autoComplete:"off",
                                    name:'delivered_by',
                                    id:'delivered_by',
                                    required:true
                                }}
                                options={this.state.medicals}
                                onSearch={this._handleSearch}
                                onChange={(e)=>this.handleTypeAheadChange(e, 'delivered_by')}
                                ref={ref => this._typeahead_delivered = ref}
                                delay={600}
                                isLoading={this.state.isLoading}
                                paginationText="Mostrar mas resultados..."
                            />
                            
                        </div>
                        <div className="col-xs-12 col-sm-1">
                            <span className="span-min">Caducidad</span>
                            <input type="date" name="expiration_date" id="expiration_date" value={this.state.expiration_date} onChange={(e)=>this.handleChange(e)} 
                                className="form-control hour-input" required />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">Temperatura de Conservación</span>
                            <input name="temperature" id="temperature" value={this.state.temperature} onChange={(e)=>this.handleChange(e)} className="form-control" required />
                        </div>
                    </div>

                    {this.state.biometrics.length > 0 &&
                        <div className="col-xs-12 form-group">
                            <fieldset>
                                <legend>Verificación Física</legend>
                                <div className="col-xs-12" style={{padding:0}}>
                                    {this.state.biometrics.map( (t, index) => 
                                        <div className="col-xs-12 col-sm-3 col-md-1" key={index}>
                                            <span className="size-min" style={{whiteSpace:"nowrap"}}>{t.name}</span>
                                        
                                            {t.data_type === 'BIO_D_SELECT' ? 
                                                <select name={'biometric_'+t.id} id={'biometric_'+t.id} 
                                                    value={t.value} className="form-control"
                                                    required={t.required}
                                                    style={{padding:5}}
                                                    onChange={(e)=>this.changeCombo(e, index)}
                                                    disabled={(!this.props.task_biometrics.create && !this.props.task_biometrics.update)||
                                                        this.state.exist_extraction}
                                                >
                                                    <option value="">Seleccione...</option>
                                                    {t.biometrics_options.map((option, i)=>
                                                        <option value={option.value} key={i}>{option.value}</option>
                                                    )}
                                                </select>
                                            : t.data_type === 'BIO_D_OPEN' ?
                                                <input 
                                                    name={'biometric_'+t.id} 
                                                    id={'biometric_'+t.id} 
                                                    value={t.value} 													
                                                    maxLength={50}
                                                    onChange={(e) => this.changeCombo(e, index)}
                                                    type="text" className="form-control"
                                                    disabled={(!this.props.task_biometrics.create && !this.props.task_biometrics.update)||
                                                        this.state.exist_extraction}
                                                    required={t.required}
                                                />
                                            :
                                                <input 
                                                    disabled={this.state.disabled_element ? true :
                                                        t.data_type === "BIO_D_CALCULATED" || 
                                                        (!this.props.task_biometrics.create && !this.props.task_biometrics.update)||
                                                        this.state.exist_extraction
                                                    } 
                                                    className="form-control bio_extraction" name={'biometric_'+t.id.toString()} 
                                                    step="0.01" type="number" min="0" 
                                                    maxLength="4"
                                                    id={'biometric_'+t.id.toString()}
                                                    onChange={(e) => this.calculateValuesBIO(e)}
                                                />
                                            }
                                        </div>
                                    )}
                                </div>
                            </fieldset>
                        </div>
                    }

                    <div className="col-xs-12 form-group">
                        <div className="col-xs-12 col-sm-4">
                            <span className="span-min">Observaciones</span>
                            <textarea 
                                className="form-control"
                                style={{height:"150px",width:"100%",resize:"none"}} 
                                name="observations" 
                                value={this.state.observations} 
                                onChange={(e)=>this.handleChange(e)}
                            >
                            </textarea>
                        </div>
                        {!this.state.edit &&
                            <div className="col-xs-12 col-sm-2" style={{marginTop:20}}>
                                <button className="btn btn-info" onClick={()=>this.addSample()}>Agregar</button>
                            </div>
                        }
                    </div>
                    
                    {!this.state.edit &&
                        <div className="col-xs-12 form-group">
                            <Table responsive hover>
                                <thead>
                                    <tr>
                                        <th>No. Muestra</th>
                                        <th>Fecha y Hora</th>
                                        <th>Tipo de Muestra</th>
                                        <th>Tipo de Tubo</th>
                                        <th>Entregada Por</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.list.map((list, i)=>
                                        <tr key={i}>
                                            <td>{list.sample_number}</td>
                                            <td>{moment(list.date).format('DD/MM/YYYY')}</td>
                                            <td>{list.sample_type}</td>
                                            <td>{list.tube_type}</td>
                                            <td>{list.delivered_by}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    }
                    <div className="col-xs-12" style={{textAlign:'center'}}>
                        <button className="btn btn-info" onClick={()=> this.state.edit ? this.addSample() : this.props.history.push('/sample_reception')}>Terminar</button>
                        <button className="btn btn-info" style={{marginLeft:8}} onClick={()=>this.props.history.push('/sample_reception')}>Regresar</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default translate('translations')(SampleReceptionForm);